export default "__VITE_ASSET__IJtD7ztr__"